import { ComponentPropsWithoutRef, ReactNode } from "react";
import { twMerge } from "tailwind-merge";
import { CardRouded } from "../CardRounded";

interface IDetailCardProps extends ComponentPropsWithoutRef<"div"> {
  /** Small gray label shown next to the icon at the top of the card. */
  label: string;
  /** Local SVG path for the label icon (from `public/assets/svgs/`). */
  icon: string;
}

/**
 * Bordered, shadowed card for the agendamento details view: a small gray
 * "icon + label" header followed by free `children`. Unlike the bare
 * `CardRouded`, border/shadow/padding apply at every breakpoint, as in Figma.
 */
export const DetailCard = ({
  label,
  icon,
  className,
  children,
  ...rest
}: IDetailCardProps) => (
  <CardRouded
    {...rest}
    className={twMerge(
      "flex flex-col gap-4 border border-solid border-[#adb7b5] bg-white p-6 shadow-[0px_8px_24px_0px_rgba(0,0,0,0.078)] md:border-[#adb7b5] md:p-6",
      className,
    )}
  >
    <div className="flex items-center gap-1.5">
      <img src={icon} alt="" className="h-3 w-3" />
      <span className="font-['Mulish'] text-xs text-[#666666]">{label}</span>
    </div>
    {children as ReactNode}
  </CardRouded>
);
